export default {
  nav_item: "text-text hover:text-primary font-medium rounded-lg text-base transition-colors px-3 py-2",

  // Primary variants ----------------------------------------->
  //36px
  primary_s:
    "w-auto h-[32px] lg:h-[36px] flex items-center justify-center gap-1.5 bg-primary hover:bg-primary_dk text-white text-sm font-semibold rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ease-in-out",

  //48px
  primary:
    "w-auto h-[40px] lg:h-[48px] flex items-center justify-center gap-1.5 bg-primary hover:bg-primary_dk text-white text-lg font-bold rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ease-in-out",

  //48px red
  primary_red:
    "w-auto h-[40px] lg:h-[48px] flex items-center justify-center gap-1.5 bg-error hover:bg-error/90 text-white text-lg font-bold rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ease-in-out",

  //36px red
  primary_red_s:
    "w-auto h-[32px] lg:h-[36px] flex items-center justify-center gap-1.5 bg-error hover:bg-error/90 text-white text-sm font-semibold rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ease-in-out",

  //48px black
  primary_black:
    "w-auto h-[40px] lg:h-[48px] flex items-center justify-center gap-1.5 bg-theme_black hover:bg-primary text-primary text-lg font-bold rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ease-in-out",

  //36px black
  primary_s_black:
    "w-auto h-[32px] lg:h-[36px] flex items-center justify-center gap-1.5 bg-theme_black hover:bg-primary text-white text-sm font-semibold rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ease-in-out",

  //48px white
  primary_white:
    "w-auto h-[40px] lg:h-[48px] flex items-center justify-center gap-1.5 bg-theme_white hover:bg-primary text-theme_black hover:text-theme_white text-lg font-bold rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ease-in-out",

  //48px white
  primary_s_white:
    "w-auto h-[32px] lg:h-[36px] flex items-center justify-center gap-1.5 bg-theme_white hover:bg-primary text-theme_black hover:text-theme_white text-sm font-semibold rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ease-in-out",

    

  // Secondary variants ----------------------------------------->
  //36px
  secondary_s:
    "w-auto h-[32px] lg:h-[36px] flex items-center justify-center gap-1.5 bg-transparent hover:bg-primary border border-primary text-primary hover:text-white text-sm font-semibold whitespace-nowrap rounded-full px-4 transition disabled:opacity-50 disabled:cursor-not-allowed",

  //48px
  secondary:
    "w-auto h-[40px] lg:h-[48px] flex items-center justify-center gap-1.5 bg-transparent hover:bg-primary border border-primary text-primary hover:text-white text-lg font-bold whitespace-nowrap rounded-full px-4 transition disabled:opacity-50 disabled:cursor-not-allowed",

  //48px red
  secondary_red:
    "w-auto h-[40px] lg:h-[48px] flex items-center justify-center gap-1.5 border border-error text-error hover:text-white text-lg font-bold hover:bg-error rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",

  //36px red
  secondary_red_s:
    "w-auto h-[32px] lg:h-[36px] flex items-center justify-center gap-1.5 border border-error text-error hover:text-white text-sm font-semibold hover:bg-error rounded-full py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",

  //48px white
  // secondary_inv:
  //   "w-auto h-[40px] lg:h-[48px] flex items-center justify-center gap-1.5 bg-transparent hover:bg-primary border border-white text-white text-lg font-bold whitespace-nowrap rounded-full px-4 transition disabled:opacity-50 disabled:cursor-not-allowed",

  //36px white
  // secondary_s_inv:
  //   "w-auto h-[32px] lg:h-[36px] flex items-center justify-center gap-1.5 bg-transparent hover:bg-primary border border-white text-white text-sm font-bold whitespace-nowrap rounded-full px-4 transition disabled:opacity-50 disabled:cursor-not-allowed",

  // Text buttons ----------------------------------------->
  text_btn: 
    "flex items-center justify-center text-text_secondary hover:text-primary hover:underline font-medium text-sm md:text-base transition-colors px-1 py-2",

  text_btn_primary: 
    "flex items-center justify-center text-primary hover:underline font-medium text-sm md:text-base transition px-1 py-2",

  text_btn_ghost:
    "flex items-center justify-center gap-2 text-text_secondary hover:text-text font-medium text-xs md:text-sm transition-colors px-3 py-2",

  // Icon buttons ----------------------------------------->
  // Gray color icons
  icon: 
    "h-[40px] flex items-center justify-center border-0 font-bold py-2 px-4 rounded text-text_secondary hover:text-primary shrink-0 transition-colors",

  // Primary color icons
  icon_primary:
    "p-1.5 rounded-lg text-primary hover:text-primary_dk hover:bg-primary/5 shrink-0 transition disabled:opacity-50 disabled:cursor-not-allowed",

  // For the Close btn
  close_icon: 
    "w-8 h-8 flex items-center justify-center rounded-full text-text_secondary hover:text-text hover:bg-neutral shrink-0 transition-colors",

  // Like buttons (for Blog articles) --------------------->
  like_btn:
    "h-8 md:h-10 flex items-center justify-start gap-1 border-transparent hover:text-primary hover:border-b-2 hover:border-primary active:scale-95 transition-all duration-200 ease-in-out cursor-pointer focus:outline-none rounded-sm",

  like_btn_big:
    "w-auto h-[40px] md:h-[44px] lg:h-[48px] flex items-center justify-center border-[1px] border-primary hover:border-primary_hov bg-transparent text-primary text-[16px] font-normal hover:font-bold rounded-full px-[16px] md:px-[18px] xl:px-[20px] transition",

  // Sign In buttons ---------------------------------------->
  sign_in_option:
    "w-full max-w-[374px] h-[40px] flex items-center justify-center gap-2 bg-primary hover:bg-primary_hov text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  sign_in_option_disabled:
    "w-full max-w-[374px] h-[40px] flex items-center justify-center gap-2 border border-primary/50 text-primary/70 font-bold rounded-full py-2 px-4 cursor-not-allowed",
}
